import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map, timeout } from 'rxjs';
import { environment } from '../../environments/environment';

export interface Amorce {
  id: number;
  code: string;
  nom_officiel: string | null;
  cible_id: number | null;
  longueur: number | null;
  forward: string | null;
  reverse: string | null;
  cible_nom: string | null;
}

export interface AmorcePayload {
  code: string;
  nom_officiel?: string | null;
  cible_id?: number | null;
  longueur?: number | null;
  forward?: string | null;
  reverse?: string | null;
}

@Injectable({ providedIn: 'root' })
export class AmorcesService {
  private readonly baseUrl = `${environment.apiBaseUrl}/api/amorces`;
  private readonly requestTimeoutMs = 30000;

  constructor(private readonly http: HttpClient) {}

  list(): Observable<Amorce[]> {
    return this.http
      .get<{ items?: Amorce[] } | Amorce[]>(this.baseUrl)
      .pipe(
        timeout(this.requestTimeoutMs),
        map((response) => {
          if (Array.isArray(response)) {
            return response;
          }
          return Array.isArray(response?.items) ? response.items : [];
        })
      );
  }

  create(payload: AmorcePayload): Observable<Amorce> {
    return this.http
      .post<Amorce>(this.baseUrl, payload)
      .pipe(timeout(this.requestTimeoutMs));
  }

  update(id: number, payload: AmorcePayload): Observable<Amorce> {
    return this.http
      .put<Amorce>(`${this.baseUrl}/${id}`, payload)
      .pipe(timeout(this.requestTimeoutMs));
  }

  delete(id: number): Observable<{ deleted: boolean; id: number }> {
    return this.http
      .delete<{ deleted: boolean; id: number }>(`${this.baseUrl}/${id}`)
      .pipe(timeout(this.requestTimeoutMs));
  }
}
